import React, { Component } from "react";

import { withStyles } from '@mui/styles';
import styles from './index.styles';
import { withTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow, Tooltip, TableSortLabel, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Card, CardContent, Typography, Grid, CircularProgress, LinearProgress } from "@mui/material";
import { Box } from "@mui/system";
import spinner from './images/spinner.gif';
import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from "prop-types";
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import BinStatusLegend, { BIN_STATUS_LEGEND } from './BinStatusLegend';
import classNames from 'classnames';

let FilterObj = {
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: ''
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (array && array.length <= 0) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

function formatDisplayBinId(item) {
    const safeItem = item || {};
    const directBin =
        safeItem.bin_id !== undefined && safeItem.bin_id !== null
            ? safeItem.bin_id
            : safeItem.binID !== undefined && safeItem.binID !== null
                ? safeItem.binID
                : safeItem.current_bin_id !== undefined && safeItem.current_bin_id !== null
                    ? safeItem.current_bin_id
                    : safeItem.currentBinId;

    if (directBin !== undefined && directBin !== null && String(directBin).trim() !== "") {
        const token = String(directBin).trim();
        if (/^\d+$/.test(token)) return token.padStart(3, '0');
        return token.toUpperCase();
    }

    const legacy = String(safeItem.binPosition || '').trim();
    const hashMatch = legacy.match(/#\s*(\d+)/);
    if (hashMatch && hashMatch[1]) return hashMatch[1].padStart(3, '0');
    return legacy || '-';
}

class EnhancedTableHead extends React.Component {
    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    };

    render() {
        const {
            order,
            orderBy,
            sortId,
            t
        } = this.props;
        const rows = [
            { id: "name", numeric: false, disablePadding: false, label: t('Task.Patient'), field: 'name', width: '24%' },
            { id: "stock_code", numeric: false, disablePadding: false, label: t('Unplugged.SearchPopup.StockCode'), field: 'stock_code', width: '22%' },
            { id: "pucode", numeric: false, disablePadding: false, label: t('Console.ActionPopup.PickupCode'), field: 'pucode', width: '22%' },
            { id: "bin_position", numeric: false, disablePadding: false, label: t('Fastlan.Component.BinPosition'), field: 'bin_position', width: '32%' },
        ];

        return (
            <TableHead>
                <TableRow>
                    <TableCell style={{ border: 'none', width: 24 }} />
                    {rows.map((row) => (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{
                                    width: row.width,
                                    textAlign: 'left',
                                    verticalAlign: 'middle',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                <Tooltip
                                    title={t("Global.Label.Filter.Sort")}
                                    placement={"right"}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.field && sortId === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id, row.field)}
                                        sx={{ '& .MuiTableSortLabel-icon': { opacity: 0.4 } }}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

export class FastlaneProLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            binsCount: 1,
            rowsPerPagePending: 10,
            hasMore: true,
            BoxID: this.props.BoxID,
            order: "desc",
            orderBy: "created_on",
            isFiltered: false,
            status: 'All',
            fastlaneBinsMatrix: { _recentOrders: [] },
            availableBins: 0,
            yourPosition: 0,
            isRetrying: false,
            retryCount: 0,
            maxRetries: 3,
            retryMessage: '',
            showRetryError: false,
            isRefreshing: false
        }
    }

    componentDidMount() {
        this.fetchFastlaneBinMatrix('All');
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.BoxID !== prevProps.BoxID) {
            this.setState({ BoxID: this.props.BoxID });
            this.fetchFastlaneBinMatrix('All');
        }
        if (this.props.makeAPICall !== prevProps.makeAPICall && this.props.makeAPICall) {
            this.setState({ BoxID: this.props.BoxID });
            this.reloadGrid();
        }
        
        // Only non-Goliath fastlane flows use YourPosition.
        if (this.props.prefix === 'FASTLANEGOLIATH') {
            return;
        }
        // Only log and update when YourPosition actually changes
        const currentYourPosition = this.state.fastlaneBinsMatrix && this.state.fastlaneBinsMatrix.YourPosition;
        const prevYourPosition = prevState && prevState.fastlaneBinsMatrix && prevState.fastlaneBinsMatrix.YourPosition;
        
        if (currentYourPosition !== prevYourPosition && 
            ![undefined, 'undefined', null, 'null', '', 0].includes(currentYourPosition) && 
            !isNaN(currentYourPosition)) {
            // Store in component state only - NO localStorage
            console.log('? Fastlane - Bin position updated:', currentYourPosition);
            // Pass to parent via callback if provided
            if (this.props.onBinPositionUpdate) {
                this.props.onBinPositionUpdate(currentYourPosition);
            }
        }
    }

    handleStockCodeClick = (event, item) => {
        event && event.preventDefault();
        this.props.getPrescriptionDetails(item.bin_id, item.order_id, item.stock_code);
    }

    fetchMoreData = (type) => {
        const { fastlaneBinsMatrix } = this.state;
        const _recentOrders = fastlaneBinsMatrix._recentOrders.length && fastlaneBinsMatrix._recentOrders;
        if (type === 'pending') {
            let total = 0;
            total = _recentOrders.length;
            if (total > 0) {
                this.setState({ total: this.state.total + total, rowsPerPagePending: this.state.rowsPerPagePending + 10 });
            } else {
                this.setState({ hasMore: false });
            }
        }
    }

    handleRequestSort = (event, property, field) => {
        const { status } = this.state;
        const orderBy = property;
        let order = "desc";
        if (this.state.orderBy === orderBy) {
            order = this.state.order === "asc" ? "desc" : "asc";
        } else if (this.state.order === order) {
            order = "asc";
        } else {
            order = "desc";
        }
        this.setState({ order, orderBy, sortId: property });
        FilterObj.sortOrder = order;
        FilterObj.sortColumn = field;
        FilterObj.tableName = property === 'name' ? 'customers' : property === 'bin_position' ? 'fastlane_matrix' : '';
        this.fetchFastlaneBinMatrix(status)
    };

    handleStatusClick = (e, label) => {
        e && e.preventDefault();
        this.setState({ isFiltered: true, status: label });
        this.fetchFastlaneBinMatrix(label)
    }

    fetchFastlaneBinMatrixWithRetry = async (status, retryCount = 0) => {
        const { maxRetries } = this.state;
        const { t } = this.props;
        const boxId = (this.props && this.props.selectedBox && this.props.selectedBox.id) || 
                     (this.props && this.props.BoxID) ||
                     (this.props && this.props.box_id);
        
        console.log('FastlaneProLayout - fetchFastlaneBinMatrix attempt:', { 
            boxId, 
            retryCount,
            status 
        });
        
        if ([undefined, 'undefined', null, 'null', ''].includes(boxId)) {
            console.warn('FastlaneProLayout - No valid boxId found');
            this.setState({ 
                fastlaneBinsMatrix: { _recentOrders: [] },
                availableBins: 0,
                yourPosition: 0,
                isRefreshing: false
            });
            return;
        }
        
        try {
            let URL = process.env.REACT_APP_BASEURL + `fastlane/matrix?boxId=${boxId}&status=${status}&tableName=${FilterObj.tableName}&sortColumn=${FilterObj.sortColumn}&sortOrder=${FilterObj.sortOrder}`;
            if(this.props.prefix === 'FASTLANEGOLIATH') {
                URL = process.env.REACT_APP_BASEURL + `fastlane-goliath/matrix?boxId=${boxId}&status=${status}&tableName=${FilterObj.tableName}&sortColumn=${FilterObj.sortColumn}&sortOrder=${FilterObj.sortOrder}`;
            }
            const response = await fetch(
                URL,
                {
                    method: 'get',
                    withCredentials: true,
                    headers: {
                        Authorization:
                            'Bearer ' +
                            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                        'Content-Type': 'application/json',
                    },
                }
            );
            
            const fastlaneBinsMatrixResponse = await response.json();
            const data = fastlaneBinsMatrixResponse && fastlaneBinsMatrixResponse.data;
            
            if (data) {
                this.setState({ 
                    fastlaneBinsMatrix: data,
                    isRetrying: false,
                    retryCount: 0,
                    retryMessage: '',
                    showRetryError: false,
                    isRefreshing: false
                });
                if (this.state.isFiltered === false) {
                    this.setState({
                        availableBins:
                            this.props.prefix === 'FASTLANEGOLIATH'
                                ? 0
                                : data.AvailableBins,
                        yourPosition: data.YourPosition,
                    });
                    // Store in component state only - NO localStorage
                    if (
                        this.props.prefix !== 'FASTLANEGOLIATH' &&
                        ![undefined, 'undefined', null, 'null', '', 0].includes(data.YourPosition)
                    ) {
                        console.log('? Fastlane - Bin position available:', data.YourPosition);
                        // Pass to parent via callback if provided
                        if (this.props.onBinPositionUpdate) {
                            this.props.onBinPositionUpdate(data.YourPosition);
                        }
                    }
                }
            } else {
                console.error('No data received from Fastlane matrix API');
                return null;
            }
        } catch (error) {
            console.error(`Fastlane matrix fetch attempt ${retryCount + 1} failed:`, error);
            
            if (retryCount < maxRetries - 1) {
                this.setState({
                    retryCount: retryCount + 1,
                    retryMessage: t('Assign.Fastlane.RetryingAttempt', { 
                        attempt: retryCount + 2, 
                        total: maxRetries 
                    })
                });
                
                await new Promise(resolve => setTimeout(resolve, 1000));
                return await this.fetchFastlaneBinMatrixWithRetry(status, retryCount + 1);
            } else {
                this.setState({ 
                    isRetrying: false,
                    retryCount: 0,
                    retryMessage: '',
                    showRetryError: true,
                    fastlaneBinsMatrix: { _recentOrders: [] },
                    availableBins: 0,
                    yourPosition: 0,
                    isRefreshing: false
                });
            }
        }
    }

    fetchFastlaneBinMatrix = (status) => {
        const { t } = this.props;
        const isGoliath = this.props.prefix === 'FASTLANEGOLIATH';
        this.setState({ 
            isRetrying: isGoliath ? false : true,
            retryMessage: isGoliath
                ? ''
                : t('Assign.Fastlane.FetchingAttempt', {
                    attempt: 1,
                    total: this.state.maxRetries
                })
        });
        
        this.fetchFastlaneBinMatrixWithRetry(status, 0);
    }

    handleRetryErrorOkay = () => {
        this.setState({ 
            showRetryError: false,
            isRetrying: true,
            retryMessage: this.props.t('Assign.Fastlane.FetchingAttempt', { 
                attempt: 1, 
                total: this.state.maxRetries 
            }),
            retryCount: 0
        });
        this.fetchFastlaneBinMatrixWithRetry(this.state.status || 'All', 0);
    }

    clearFilters = () => {
        FilterObj.sortOrder = 'desc';
        FilterObj.sortColumn = 'created_on';
        FilterObj.tableName = '';
        this.fetchFastlaneBinMatrix('All');
        this.setState({ isFiltered: false, status: 'All' });
    }

    reloadGrid = () => {
        FilterObj.sortOrder = 'desc';
        FilterObj.sortColumn = 'created_on';
        FilterObj.tableName = '';
        this.setState({ isFiltered: false, isRefreshing: true })
        this.fetchFastlaneBinMatrix('All');
    }

    render() {
        const { t, isViewPermissionAllowed } = this.props;
        const { fastlaneBinsMatrix, isFiltered, availableBins, yourPosition, status, isRefreshing } = this.state;
        const isGoliath = this.props.prefix === 'FASTLANEGOLIATH';
        const loadingZoneUtilization = Number.isFinite(Number(fastlaneBinsMatrix && fastlaneBinsMatrix.loadingZoneUtilization))
            ? Number(fastlaneBinsMatrix.loadingZoneUtilization)
            : 0;
        const storageSlotsUtilization = Number.isFinite(Number(fastlaneBinsMatrix && fastlaneBinsMatrix.storageSlotsUtilization))
            ? Number(fastlaneBinsMatrix.storageSlotsUtilization)
            : 0;
        const _recentOrders = fastlaneBinsMatrix && fastlaneBinsMatrix._recentOrders;
        const hasOrders = Array.isArray(_recentOrders) && _recentOrders.length > 0;
        // Enable clear filter button only when a filter is applied (regardless of results)
        const isFilterDisabled = !isFiltered;
        
        return (
            <Box
                component='div'
                sx={{
                    width: '100%',
                    textAlign: 'center',
                    mt: '2%',
                    px: 2,
                }}
            >
                {/* Modern Card View for Available and Your Position */}
                <Grid container spacing={0.5} sx={{ mb: 0.5 }}>
                    {!isGoliath && <Grid item xs={12} sm={6}>
                        <Card
                            sx={{
                                background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                                color: 'white',
                                borderRadius: '6px',
                                boxShadow: '0 1px 4px rgba(25, 118, 210, 0.3)',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                maxHeight: '60px',
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 2px 6px rgba(25, 118, 210, 0.4)',
                                },
                                '& .MuiCardContent-root': {
                                    padding: '0.5rem !important',
                                    '&:last-child': {
                                        paddingBottom: '0.5rem'
                                    }
                                }
                            }}
                        >
                            <CardContent sx={{ py: 0.5, px: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '0.7rem',
                                        opacity: 0.9,
                                        fontWeight: 500,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.3px',
                                        lineHeight: 1.2
                                    }}
                                >
                                    {isGoliath
                                        ? t('Unplugged.AvailableBins', 'Available Bins')
                                        : t('API.DeviceType.Available')}
                                </Typography>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: 700,
                                        lineHeight: 1.2
                                    }}
                                >
                                    {availableBins}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>}
                    {!isGoliath && (
                    <Grid item xs={12} sm={6}>
                        <Card
                            sx={{
                                background: 'linear-gradient(135deg, #1565c0 0%, #42a5f5 100%)',
                                color: 'white',
                                borderRadius: '6px',
                                boxShadow: '0 1px 4px rgba(21, 101, 192, 0.3)',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                maxHeight: '60px',
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 2px 6px rgba(21, 101, 192, 0.4)',
                                },
                                '& .MuiCardContent-root': {
                                    padding: '0.5rem !important',
                                    '&:last-child': {
                                        paddingBottom: '0.5rem'
                                    }
                                }
                            }}
                        >
                            <CardContent sx={{ py: 0.5, px: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '0.7rem',
                                        opacity: 0.9,
                                        fontWeight: 500,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.3px',
                                        lineHeight: 1.2
                                    }}
                                >
                                    {t('Fastlan.Component.YourPosition')}
                                </Typography>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: 700,
                                        lineHeight: 1.2
                                    }}
                                >
                                    {yourPosition || '�'}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    )}
                </Grid>

                {/* Recent Orders — dense layout (matches unplugged / rx cart) */}
                <Box sx={{ width: '100%', px: 1, pb: 0.5 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 1,
                            py: 0.5,
                            flexWrap: 'wrap',
                        }}
                    >
                        <Typography
                            component="label"
                            sx={{
                                color: '#000',
                                fontSize: '0.85rem',
                                fontWeight: 500,
                                flex: '1 1 auto',
                                textAlign: 'left',
                                lineHeight: 1.3,
                            }}
                        >
                            {isGoliath ? t('Fastlan.Goliath.Component.Title') : t('Fastlan.Component.RecentOrdersTitle')}
                        </Typography>
                        {isGoliath && (
                            <Box
                                sx={{
                                    backgroundColor: '#fff',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '8px',
                                    px: 1,
                                    py: 0.5,
                                    minWidth: '200px',
                                    flex: '1 1 200px',
                                }}
                            >
                                <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#0f172a', lineHeight: 1.2 }}>
                                    {t('Fastlan.Goliath.UtilizationTitle', 'Slot Utilization (% full)')}
                                </Typography>
                                <Typography sx={{ fontSize: '0.75rem', color: '#64748b', lineHeight: 1.25, mt: 0.25 }}>
                                    {t('Fastlan.Goliath.LoadingZone', 'Loading Zone')}: {loadingZoneUtilization}%
                                </Typography>
                                <Typography sx={{ fontSize: '0.75rem', color: '#64748b', lineHeight: 1.25 }}>
                                    {t('Fastlan.Goliath.StorageSlots', 'Storage Slots')}: {storageSlotsUtilization}%
                                </Typography>
                            </Box>
                        )}
                        <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
                            <Tooltip key="reload-grid" title={t("Reload")}>
                                <IconButton
                                    onClick={() => this.reloadGrid()}
                                    disabled={isRefreshing}
                                    size="small"
                                    sx={{ backgroundColor: 'transparent', p: 0.5 }}
                                >
                                    {isRefreshing ? <CircularProgress size={16} /> : <RefreshRoundedIcon fontSize="small" />}
                                </IconButton>
                            </Tooltip>
                            <Tooltip key="clear-filters" title={t("Report.Assign.ClearFiltersTooltip")}>
                                <IconButton
                                    disabled={isFilterDisabled}
                                    onClick={() => this.clearFilters()}
                                    size="small"
                                    sx={{ backgroundColor: 'transparent', p: 0.5 }}
                                >
                                    <FilterAltOffOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                    {isRefreshing && <LinearProgress sx={{ height: 2 }} />}
                    <Box className="recent-orders-list-shell">
                        <Box className="recent-orders-list-head">
                            <Table size="small" className="recent-orders-table">
                                <EnhancedTableHead
                                    order={FilterObj.sortOrder}
                                    orderBy={FilterObj.sortColumn}
                                    sortId={this.state.sortId}
                                    onRequestSort={this.handleRequestSort}
                                />
                            </Table>
                        </Box>
                        <Box
                            id="fastlane-scrollable-container"
                            className={classNames('recent-orders-list-body', {
                                'is-empty': !hasOrders,
                            })}
                        >
                            <InfiniteScroll
                                dataLength={this.state.rowsPerPagePending}
                                next={() => this.fetchMoreData('pending')}
                                hasMore={this.state.hasMore}
                                scrollableTarget="fastlane-scrollable-container"
                                endMessage={
                                    <p style={{ textAlign: 'center', margin: '8px 0', fontSize: '0.75rem' }}>
                                        <b>{t("Console.YouHaveSeenIt")}</b>
                                    </p>
                                }>
                                <Table size="small" className="recent-orders-table">
                                    <TableBody>
                                        {hasOrders ? stableSort(_recentOrders, getSorting(FilterObj.sortOrder, FilterObj.sortColumn)).map((item, index) => (
                                            <TableRow key={`${item.stock_code || ''}-${item.bin_id || index}`}>
                                                <TableCell style={{ border: 'none' }}>
                                                    <Tooltip title={item && item.rowProperties && item.rowProperties.type}>
                                                        <span
                                                            style={{
                                                                background: item && item.rowProperties && item.rowProperties.bgColor,
                                                                border: '1px solid #888',
                                                                borderRadius: '50%',
                                                                height: '14px',
                                                                width: '14px',
                                                                display: 'inline-block',
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {item.name}
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {isViewPermissionAllowed ? (
                                                        <a
                                                            href=""
                                                            onClick={(event) => this.handleStockCodeClick(event, item)}
                                                        >
                                                            {item.stock_code}
                                                        </a>
                                                    ) : item.stock_code}
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {item.pucode}
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'left' }}>
                                                    {formatDisplayBinId(item)}
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow>
                                                <TableCell style={{ borderBottom: 'none' }} />
                                                <TableCell
                                                    colSpan={4}
                                                    className="recent-orders-empty-cell"
                                                    style={{ borderBottom: 'none' }}
                                                >
                                                    {t("Unplugged.NoDataFound")}
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </InfiniteScroll>
                        </Box>
                    </Box>
                    <BinStatusLegend
                        items={BIN_STATUS_LEGEND}
                        onItemClick={this.handleStatusClick}
                        activeLabel={isFiltered ? status : undefined}
                    />
                </Box>
                
                <Dialog
                    open={!isGoliath && (this.state.isRetrying || false)}
                    aria-labelledby='fastlane-retry-dialog-title'
                    aria-describedby='fastlane-retry-dialog-description'
                    disableEscapeKeyDown
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                            return false;
                        }
                    }}
                    PaperProps={{
                        style: { 
                            minWidth: '400px'
                        }
                    }}
                    BackdropProps={{
                        style: {
                            backgroundColor: 'rgba(0, 0, 0, 0.7)'
                        }
                    }}
                >
                    <DialogTitle id='fastlane-retry-dialog-title' sx={{ textAlign: 'center', color: '#1976d2' }}>
                        {t('Assign.Fastlane.RetryDialogTitle')}
                    </DialogTitle>
                    <DialogContent sx={{ textAlign: 'center', pb: 3, pt: 2 }}>
                        <Box component='div' sx={{ mb: 2 }}>
                            <img
                                src={spinner}
                                alt='loading'
                                style={{ width: '50px', height: '50px' }}
                            />
                        </Box>
                        <DialogContentText id='fastlane-retry-dialog-description' sx={{ fontSize: '1rem', fontWeight: 600, color: '#000' }}>
                            {this.state.retryMessage}
                        </DialogContentText>
                        <DialogContentText sx={{ mt: 1, fontSize: '0.875rem', color: '#666' }}>
                            {t('Assign.Fastlane.RetryMessage')}
                        </DialogContentText>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={!isGoliath && (this.state.showRetryError || false)}
                    aria-labelledby='fastlane-error-dialog-title'
                    aria-describedby='fastlane-error-dialog-description'
                    disableEscapeKeyDown
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                            return false;
                        }
                    }}
                >
                    <DialogTitle id='fastlane-error-dialog-title' sx={{ color: '#d32f2f' }}>
                        {t('Assign.Fastlane.ErrorDialogTitle')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id='fastlane-error-dialog-description'>
                            {t('Assign.Fastlane.ErrorMessage')}
                        </DialogContentText>
                        <DialogContentText sx={{ mt: 2, fontWeight: 500 }}>
                            {t('Assign.Fastlane.ErrorQuestion')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleRetryErrorOkay}
                            color='primary'
                            autoFocus
                        >
                            {t('Assign.Fastlane.TryAgainButton')}
                        </Button>
                        <Button
                            onClick={() => this.setState({ showRetryError: false })}
                            color='primary'
                        >
                            {t('Assign.CancelButton')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        )
    }
}

export default withStyles(styles)(withTranslation()(FastlaneProLayout));


// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/fastlane-pro.js